// src/utils/formatters.js
// ⚠️ COMPLETO: original + mis 4 adiciones. Reemplaza TODO el archivo.

export const numberFormat = new Intl.NumberFormat('es-PE');

export const moneyFormat = new Intl.NumberFormat('es-PE', {
    style: 'currency',
    currency: 'PEN',
    minimumFractionDigits: 2,
});

export const toNumber = (value) => Number(value || 0);

export const formatNumber = (value) => numberFormat.format(toNumber(value));

export const formatMoney = (value) => moneyFormat.format(toNumber(value));

export const formatOrderCode = (id) => `OS-${String(id || '').padStart(5, '0')}`;

export const percentage = (value, total) => {
    const safeTotal = toNumber(total);
    if (!safeTotal) return 0;

    return Math.round((toNumber(value) / safeTotal) * 100);
};

export const formatDate = (value) => {
    if (!value) return '-';

    let date;

    if (typeof value === 'string') {
        const raw = value.trim();

        if (/^\d{4}-\d{2}-\d{2}/.test(raw)) {
            const [year, month, day] = raw.slice(0, 10).split('-').map(Number);
            date = new Date(year, month - 1, day);
        } else {
            date = new Date(raw);
        }
    } else if (value instanceof Date) {
        const year = value.getUTCFullYear();
        const month = value.getUTCMonth();
        const day = value.getUTCDate();

        date = new Date(year, month, day);
    } else {
        return '-';
    }

    if (Number.isNaN(date.getTime())) return '-';

    return new Intl.DateTimeFormat('es-PE', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
    }).format(date);
};

// ==========================================================
// ADICIONES para el reporte de tracking de manifiestos
// ==========================================================

export const formatManifestCode = (id) => `MN-${String(id || '').padStart(6, '0')}`;

export const formatDuration = (seconds) => {
    const s = Math.max(0, Math.floor(Number(seconds) || 0));
    if (s === 0) return '0m';

    const h = Math.floor(s / 3600);
    const m = Math.floor((s % 3600) / 60);
    const sec = s % 60;

    if (h > 0) return `${h}h ${m}m`;
    if (m > 0) return `${m}m ${sec}s`;
    return `${sec}s`;
};

export const formatDateTime = (value) => {
    if (!value) return '-';
    const d = value instanceof Date ? value : new Date(value);
    if (Number.isNaN(d.getTime())) return '-';

    return new Intl.DateTimeFormat('es-PE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    }).format(d);
};

export const formatPercent = (value) => `${Math.round(Number(value) || 0)}%`;